import { memo } from "react";
import Image from "next/image";
import PropTypes from "prop-types";
import { addDofollowToAnchors } from "../utils/modifyHtmlLinks";
import { useRouter } from "next/router";

const ServicesDetails = memo(({ serviceIntro, className = "" }) => {
  const router = useRouter();
  const lang = router.locale || "en";

  return (
    <section
      className={`w-full self-stretch flex flex-row items-start justify-end px-6 sm:px-6 lg:px-20 py-[40px] lg:py-[60px] box-border text-text-primary max-w-[1600px] mx-auto  ${className}`}
    >
      <div className="flex-1 flex flex-col items-start justify-start gap-10 max-w-full">
        {/* Answer-first intro: server-rendered, directly after the H1, before the logos */}
        {serviceIntro?.introduction && (
          <p className="m-0 w-full text-[16px] sm:text-[18px] leading-[150%] max-w-full">
            {serviceIntro.introduction}
          </p>
        )}

        <div className="self-stretch flex flex-col lg:flex-row items-start justify-start gap-[60px] max-w-full shrink-0">
          <div className="w-full lg:w-1/3 flex flex-col items-start justify-start p-0 box-border max-w-full">
            <h2 className="m-0 relative text-[28px] sm:text-[32px] lg:text-[40px] leading-[120%] font-medium">
              {serviceIntro?.title}
            </h2>
          </div>
          {serviceIntro?.description && (
            <div
              className="w-full flex-1 relative text-[16px] leading-[150%] inline-block max-w-full rich-text"
              dangerouslySetInnerHTML={{
                __html: addDofollowToAnchors(serviceIntro.description) || "",
              }}
            />
          )}
        </div>
        <div className="self-stretch h-px relative border-gray-500 border-solid border-t-[1px] border-gray-500 box-border" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[30px] w-full max-w-full">
          <div className="flex items-center justify-center gap-4 w-full max-w-full">
            <Image
              className="w-full relative object-contain"
              loading="lazy"
              width={120}
              height={80}
              alt={
                lang === "ar"
                  ? "شارة شريك معتمد Zoho – حلول تسويق رقمي معتمدة للشركات الناشئة في الإمارات"
                  : "Zoho Authorized Partner badge – Certified Digital Marketing Solutions for Startups in UAE"
              }
              src="/zohoauthorizedbadgenew-1@2x.png"
            />
          </div>
          <div className="flex items-center justify-center gap-4 w-full max-w-full">
            <Image
              className="relative object-cover"
              loading="lazy"
              width={125}
              height={80}
              alt={
                lang === "ar"
                  ? "شعار شريك أعمال Meta – خبرة تسويق رقمي للشركات الناشئة من بريزم ديجيتال الإمارات"
                  : "Meta business partner logo – Digital Marketing expertise for startups by Prism Digital UAE"
              }
              src="/meta-1@2x.png"
            />
          </div>
          <div className="flex items-center justify-center gap-4 w-full max-w-full">
            <Image
              className="relative object-cover"
              loading="lazy"
              width={80}
              height={80}
              alt={
                lang === "ar"
                  ? "استراتيجيات وأدوات التسويق الرقمي للشركات الناشئة – بريزم ديجيتال الإمارات"
                  : "Digital marketing strategies and tools for startups – Prism Digital Agency UAE"
              }
              src="/images-1@2x.png"
            />
          </div>
          <div className="flex items-center justify-center gap-4 w-full max-w-full">
            <Image
              className="relative object-cover"
              loading="lazy"
              width={93}
              height={80}
              alt={
                lang === "ar"
                  ? "مراجعات وتقييمات العملاء لنجاح الشركات الناشئة في التسويق الرقمي – بريزم ديجيتال الإمارات"
                  : "Customer profile reviews and ratings showcasing startup digital marketing success – Prism Digital UAE"
              }
              src="/profilereviews-1@2x.png"
            />
          </div>
        </div>
      </div>
    </section>
  );
});

ServicesDetails.propTypes = {
  serviceIntro: PropTypes.shape({
    title: PropTypes.string,
    introduction: PropTypes.string,
    description: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default ServicesDetails;
